import { create } from 'zustand';

const STORAGE_KEY = 'maestro_hidden_usb_devices';

function loadHiddenIds(): string[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
}

function persistHiddenIds(ids: string[]) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(ids));
}

interface HiddenDevicesStore {
  hiddenIds: string[];
  hideDevice: (deviceId: string) => void;
  unhideDevice: (deviceId: string) => void;
  clearAll: () => void;
  isHidden: (deviceId: string) => boolean;
}

export const useHiddenDevicesStore = create<HiddenDevicesStore>((set, get) => ({
  hiddenIds: loadHiddenIds(),

  hideDevice: (deviceId: string) => {
    const current = get().hiddenIds;
    if (current.includes(deviceId)) return;
    const updated = [...current, deviceId];
    persistHiddenIds(updated);
    set({ hiddenIds: updated });
  },

  unhideDevice: (deviceId: string) => {
    const updated = get().hiddenIds.filter((id) => id !== deviceId);
    persistHiddenIds(updated);
    set({ hiddenIds: updated });
  },

  clearAll: () => {
    persistHiddenIds([]);
    set({ hiddenIds: [] });
  },

  isHidden: (deviceId: string) => {
    return get().hiddenIds.includes(deviceId);
  },
}));
